import { useFormContext } from '@/contexts/form-context';
import { useBankAccountSelectionUrlQuery } from '@/hooks/payment-user/queries/use-bank-account-selection-url.query';
import { useBankAccountSelectionResult } from '@/hooks/payout-account/use-bank-account-selection-result';
import notify from '@/utils/shared/notify';
import { generateBankAccountSelectionCallbackUrl } from '@/utils/payment/payment-user';
import { useField } from '@tanstack/react-form';
import { useLocation } from 'react-router-dom';

export default function BankAccountSelectionButton() {
  const { pathname } = useLocation();
  const { data, isLoading } = useBankAccountSelectionUrlQuery(generateBankAccountSelectionCallbackUrl(pathname));
  const { id, errorCode, errorMessage } = useBankAccountSelectionResult();
  const form = useFormContext();

  const field = useField({
    form,
    name: 'selectionId',
  });

  return (
    <div className="mt-4">
      <div className="flex items-center">
        <button
          type="button"
          disabled={isLoading}
          className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white"
          onClick={async (e) => {
            e.stopPropagation();

            if (!data && true) {
              notify.error('Det går inte att välja bankkonto just nu. Försök igen senare.');
              return;
            }

            window.location.href = data.url;
          }}
        >
          {id || errorCode ? 'Välj annat bankkonto' : 'Välj bankkonto'}
          {isLoading && (
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              fill="white"
              className="ml-2"
            >
              <path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z">
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  dur="0.75s"
                  values="0 12 12;360 12 12"
                  repeatCount="indefinite"
                />
              </path>
            </svg>
          )}
        </button>

        {id && <SuccessBadge />}
        {errorCode && <ErrorBadge />}
      </div>
      {Boolean(field.state.meta.errors) && (
        <div className="mt-4 text-red-700" role="alert" aria-live="polite">
          {field.state.meta.errors.join(', ')}
        </div>
      )}
      {errorMessage && <div className="mt-4 text-red-700">{errorMessage}</div>}
    </div>
  );
}

const SuccessBadge = () => {
  return (
    <>
      <div className="block w-px h-8 bg-gray-200 dark:bg-gray-700 mx-5 my-0" aria-hidden="true"></div>
      <div>
        <div className="text-sm inline-flex font-medium bg-green-500/20 text-green-700 rounded-full text-center px-2.5 py-1">
          Bankkonto valt
        </div>
      </div>
    </>
  );
};

const ErrorBadge = () => {
  return (
    <>
      <div className="block w-px h-8 bg-gray-200 dark:bg-gray-700 mx-5 my-0" aria-hidden="true"></div>
      <div>
        <div className="text-sm inline-flex font-medium bg-red-500/20 text-red-700 rounded-full text-center px-2.5 py-1">
          Kontoval misslyckades
        </div>
      </div>
    </>
  );
};
